/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-07 14:28:58
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-12 14:01:23
 * @name: 我的售后-待审批列表页面对象
 * @Description: 我的售后-待审批列表页面对象
 * @FilePath: \project\src\views\index\afterSaleWaitDeal\afterSaleWaitDealList\afterSaleWaitDealList.view.js
 * @Author: desktop
 */
import { debounceation } from "@/utils/decorator";
import issueService from "@/module/issue/issue.service";
const afterSaleWaitDealListView = class {
  constructor() {
    this.issueService = new issueService();
    // 搜索条件
    this.searchForm = {
      piano_no: '',
      type: 'all',
    };
    // 分页信息
    this.pagination = {
      page: 1,
      limit: 10,
    };
    this.typeList = [
      //状态数组
      {
        value: "all",
        text: "全部",
      },
      {
        value: "todo",
        text: "待处理",
      },
      {
        value: "finish",
        text: "已处理",
      },
    ];
    this.tableLoading = false;
    this.tableTotal = 0;
    this.tableData = [];
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 查询
   */
  @debounceation(300)
  onQuery() {
    this.initPagination();
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 刷新
   */
  @debounceation(300)
  initData() {
    this.initSearchForm(); //初始化搜索条件表单
    this.initPagination(); //初始化分页信息
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 初始化搜索条件表单
   */
  initSearchForm() {
    this.searchForm = {
      piano_no: '',
      type: 'all',
    };
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 初始化分页信息
   */
  initPagination() {
    this.pagination = {
      page: 1,
      limit: 10,
    };
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取表格数据
   */
  getTableData() {
    let {
      piano_no,
      type,
    } = this.searchForm ?? {};
    let pagination = this.pagination ?? {};
    let req = {
      piano_no,
      type,
      ...pagination,
    }
    this.tableLoading = true;
    this.issueService.issueGetTodoList(req).then(res => {
      this.tableTotal = res.data.total;
      this.tableData = res.data.data.map(x => {
        x.piano_model = x.piano_model || '/';
        x.piano_no = x.piano_no || '/';
        x.issue_name = x.musical === '其它' ? x.musical : x.issue_name;
        x.positions = x.positions || '/';
        x.questions = x.questions || '/';
        x.statuText = this.issueService.getStatusText(x, { successText: '已审批' });
        return x;
      });
    }).finally(() => {
      this.tableLoading = false;
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 跳转详情
   * @param {Object} row 行数据
   */
  @debounceation(300)
  toDetail(row) {
    this.issueService.pushToDetail('/index/afterSale', row);
  }
}

export default afterSaleWaitDealListView;